import { useState } from 'react';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { isUserAuthorised } from './usePermissionLoader';

type UsePermission = {
    [name: string]: MedicationsPermissions | MedicationsPermissions[];
};

export function useAnyPermission(permissions: MedicationsPermissions[]) {
    for (const permissionsKey of permissions) {
        if (isUserAuthorised(permissionsKey)) return true;
    }

    return false;
}

export function usePermissions<T extends UsePermission>(permissions: T): { [P in keyof T]?: boolean } {
    const [permissionsResults] = useState(() => {
        return Object.entries(permissions).reduce(
            (currentPermissions, nextPermissions: [string, MedicationsPermissions | MedicationsPermissions[]]) => {
                return {
                    ...currentPermissions,
                    [nextPermissions[0]]: isUserAuthorised(nextPermissions[1])
                };
            },
            {}
        );
    });

    return permissionsResults;
}
